import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';

@Component({
  selector: 'app-view-outcome-modal',
  templateUrl: './view-outcome-modal.page.html',
  styleUrls: ['./view-outcome-modal.page.scss'],
})
export class ViewOutcomeModalPage implements OnInit {

  public Outcome: any = {};

  constructor(public modalController: ModalController) { }

  ngOnInit() {
    document.getElementById('closeBtn').focus();
  }

  cancelModal(){
    this.modalController.dismiss();
  }

}
